// import React from "react";
// import {
//   FaBook,
//   FaSmile,
//   FaBriefcase,
//   FaHandshake,
//   FaUserTie,
//   FaChalkboardTeacher,
//   FaGraduationCap,
//   FaLightbulb,
//   FaHeart,
//   FaBullhorn,
//   FaStar,
//   FaInstagram,
//   FaTwitter,
//   FaFacebook,
//   FaLinkedin,
//   FaTiktok,
//   FaPinterest,
//   FaYoutube,
// } from "react-icons/fa";
import {
  SocialMediaOption,
  HashtagCountOption,
  WritingToneOption,
} from "./types";

// export const socialMediaOptions: SocialMediaOption[] = [
//   { value: "Instagram", label: <React.Fragment><FaInstagram color="#E1306C" /> Instagram</React.Fragment> },
//   { value: "Twitter", label: <><FaTwitter color="#1DA1F2" /> Twitter</> },
//   { value: "Facebook", label: <><FaFacebook color="#1877F2" /> Facebook</> },
//   { value: "LinkedIn", label: <><FaLinkedin color="#0077B5" /> LinkedIn</> },
//   { value: "TikTok", label: <><FaTiktok color="black" /> TikTok</> },
//   { value: "Pinterest", label: <><FaPinterest color="#E60023" /> Pinterest</> },
//   { value: "YouTube", label: <><FaYoutube color="red" /> YouTube</> },
// ];
export const socialMediaOptions: SocialMediaOption[] = [
  {
    value: "Instagram",
    label: "Instagram",
    // label: (
    //   <React.Fragment>
    //     <FaInstagram color="#E1306C" /> Instagram
    //   </React.Fragment>
    // ),
  },
  {
    value: "Twitter",
    label: "Twitter",
    // label: (
    //   <>
    //     <FaTwitter color="#1DA1F2" /> Twitter
    //   </>
    // ),
  },
  {
    value: "Facebook",
    label: "Facebook",
    // label: (
    //   <>
    //     <FaFacebook color="#1877F2" /> Facebook
    //   </>
    // ),
  },
  {
    value: "LinkedIn",
    label: "LinkedIn",
    // label: (
    //   <>
    //     <FaLinkedin color="#0077B5" /> LinkedIn
    //   </>
    // ),
  },
  {
    value: "TikTok",
    label: "TikTok",
    // label: (
    //   <>
    //     <FaTiktok color="black" /> TikTok
    //   </>
    // ),
  },
  {
    value: "Pinterest",
    label: "Pinterest",
    // label: (
    //   <>
    //     <FaPinterest color="#E60023" /> Pinterest
    //   </>
    // ),
  },
  {
    value: "YouTube",
    label: "YouTube",
    // label: (
    //   <>
    //     <FaYoutube color="red" /> YouTube
    //   </>
    // ),
  },
];
// export const hashtagCountOptions: HashtagCountOption[] = [
//     { value: 5, label: <>🚀 5 hashtags</> },
//     { value: 10, label: <>🔟 10 hashtags</> },
//     { value: 20, label: <>🔥 20 hashtags</> },
//   ];
export const hashtagCountOptions: HashtagCountOption[] = [
  { value: 5, label: "5 Hashtags" },
  { value: 10, label: "10 Hashtags" },
  { value: 20, label: "20 Hashtags" },
];
// export const writingToneOptions: WritingToneOption[] = [
//   { value: "Formal", label: <><FaBook color="#007bff" /> Formal</> },
//   { value: "Casual", label: <><FaSmile color="#28a745" /> Casual</> },
//   { value: "Professional", label: <><FaBriefcase color="#ff8c00" /> Professional</> },
//   { value: "Friendly", label: <><FaHandshake color="#ff69b4" /> Friendly</> },
//   { value: "Diplomatic", label: <><FaUserTie color="#6c757d" /> Diplomatic</> },
//   { value: "Confident", label: <><FaChalkboardTeacher color="#17a2b8" /> Confident</> },
//   { value: "Middle school", label: <><FaGraduationCap color="#dc3545" /> Middle School</> },
//   { value: "High school", label: <><FaGraduationCap color="#ffc107" /> High School</> },
//   { value: "Academic", label: <><FaBook color="#6610f2" /> Academic</> },
//   { value: "Simplified", label: <><FaLightbulb color="#fd7e14" /> Simplified</> },
//   { value: "Empathetic", label: <><FaHeart color="#e83e8c" /> Empathetic</> },
//   { value: "Direct", label: <><FaBullhorn color="#20c997" /> Direct</> },
//   { value: "Engaging", label: <><FaStar color="#ffc107" /> Engaging</> },
// ];
export const writingToneOptions: WritingToneOption[] = [
  {
    value: "Formal",
    label: "Formal",
    // label: (
    //   <>
    //     <FaBook color="#007bff" /> Formal
    //   </>
    // ),
  },
  {
    value: "Casual",
    label: "Casual",
    // label: (
    //   <>
    //     <FaSmile color="#28a745" /> Casual
    //   </>
    // ),
  },
  {
    value: "Professional",
    label: "Professional",
    // label: (
    //   <>
    //     <FaBriefcase color="#ff8c00" /> Professional
    //   </>
    // ),
  },
  {
    value: "Friendly",
    label: "Friendly",
    // label: (
    //   <>
    //     <FaHandshake color="#ff69b4" /> Friendly
    //   </>
    // ),
  },
  {
    value: "Diplomatic",
    label: "Diplomatic",
    // label: (
    //   <>
    //     <FaUserTie color="#6c757d" /> Diplomatic
    //   </>
    // ),
  },
  {
    value: "Confident",
    label: "Confident",
    // label: (
    //   <>
    //     <FaChalkboardTeacher color="#17a2b8" /> Confident
    //   </>
    // ),
  },
  {
    value: "Middle school",
    label: "Middle school",
    // label: (
    //   <>
    //     <FaGraduationCap color="#dc3545" /> Middle School
    //   </>
    // ),
  },
  {
    value: "High school",
    label: "High school",
    // label: (
    //   <>
    //     <FaGraduationCap color="#ffc107" /> High School
    //   </>
    // ),
  },
  {
    value: "Academic",
    label: "Academic",
    // label: (
    //   <>
    //     <FaBook color="#6610f2" /> Academic
    //   </>
    // ),
  },
  {
    value: "Simplified",
    label: "Simplified",
    // label: (
    //   <>
    //     <FaLightbulb color="#fd7e14" /> Simplified
    //   </>
    // ),
  },
  {
    value: "Empathetic",
    label: "Empathetic",
    // label: (
    //   <>
    //     <FaHeart color="#e83e8c" /> Empathetic
    //   </>
    // ),
  },
  {
    value: "Direct",
    label: "Direct",
    // label: (
    //   <>
    //     <FaBullhorn color="#20c997" /> Direct
    //   </>
    // ),
  },
  {
    value: "Engaging",
    label: "Engaging",
    // label: (
    //   <>
    //     <FaStar color="#ffc107" /> Engaging
    //   </>
    // ),
  },
];
